"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTransferTotalSellValue = void 0;
const calculateTransferTotalSellValue = (transfer_line) => {
    let val = 0;
    if (transfer_line?.vehicle?.vehicle?.id) {
        val += transfer_line?.vehicle?.total * transfer_line?.vehicle?.quantity;
    }
    return val;
};
exports.calculateTransferTotalSellValue = calculateTransferTotalSellValue;
